var _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _g, _g2, _path, _line, _line2, _line3, _polyline, _polyline2, _polyline3, _polyline4, _polygon7, _polyline5, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 48",
    enableBackground: "new 0 0 96 48",
    xmlSpace: "preserve",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Flag of Australia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#012169",
    width: 96,
    height: 48
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "76.277,25.281 76.8,24 77.322,25.281 78.702,25.382 77.645,26.275 77.976,27.618 76.8,26.889  75.624,27.618 75.955,26.275 74.898,25.382 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "59.339,19.627 60,17.571 60.661,19.627 62.681,18.862 61.486,20.661 63.343,21.763 61.191,21.95  61.488,24.089 60,22.524 58.512,24.089 58.809,21.95 56.657,21.763 58.514,20.661 57.319,18.862 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "71.339,38.627 72,36.571 72.661,38.627 74.681,37.862 73.486,39.661 75.343,40.763 73.191,40.95  73.488,43.089 72,41.524 70.512,43.089 70.809,40.95 68.657,40.763 70.514,39.661 69.319,37.862 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "82.005,16.427 82.667,14.371 83.328,16.427 85.347,15.662 84.152,17.461 86.009,18.563  83.858,18.75 84.154,20.889 82.667,19.324 81.179,20.889 81.475,18.75 79.324,18.563 81.181,17.461 79.986,15.662 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "71.339,6.627 72,4.571 72.661,6.627 74.681,5.862 73.486,7.661 75.343,8.763 73.191,8.95  73.488,11.089 72,9.524 70.512,11.089 70.809,8.95 68.657,8.763 70.514,7.661 69.319,5.862 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "47.975,0 43.519,0 27.986,7.768 27.986,0 19.988,0 19.988,7.768 4.456,0 0,0 0,2.23 11.534,7.999  0,7.999 0,23.997 4.455,23.997 19.988,16.229 19.988,23.997 27.986,23.997 27.986,16.229 43.52,23.997 47.975,23.997 47.975,21.766  36.441,15.998 47.975,15.998 47.975,7.999 36.441,7.999 47.975,2.23 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_1_",
    points: "0,0 48,0 48,24 0,24  "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    stroke: "#FFFFFF",
    strokeWidth: 64,
    strokeMiterlimit: 426.6667,
    d: "M48,24 M0,0 M0,24 M48,0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M48,12v12l0,0 M0,0 M24,24H0l0,0 M48,0H24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    stroke: "#E4002B",
    strokeWidth: 42.6667,
    strokeMiterlimit: 426.6667,
    d: "M48,24 M0,0 M0,24  M48,0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 106.6667,
    strokeMiterlimit: 426.6667,
    d: "M24,24 M24,0 M48,12"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#E4002B",
    x1: 48,
    y1: 9.6,
    x2: 48,
    y2: 14.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "#E4002B",
    x1: 21.6,
    y1: 0,
    x2: 26.4,
    y2: 0
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "#E4002B",
    x1: 26.4,
    y1: 24,
    x2: 21.6,
    y2: 24
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "_x31_3_1_",
    fill: "#CF142B",
    points: "26.386,23.997 26.386,14.391 47.975,14.391 47.975,9.593 26.386,9.593 26.386,0  21.588,0 21.588,9.593 0,9.593 0,14.391 21.588,14.391 21.588,23.997 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "_x35__1_",
    fill: "#012169",
    points: "0,21.766 0,15.998 11.534,15.998 0,21.766 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "_x34__1_",
    fill: "#CF142B",
    points: "47.975,0 45.31,0 29.344,7.999 32.009,7.999 48,0 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "_x33__3_",
    fill: "#CF142B",
    points: "18.631,15.998 15.966,15.998 0,23.997 2.664,23.997 18.656,15.998 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "_x32__1_",
    fill: "#CF142B",
    points: "13.323,8.005 15.987,8.005 0,0 0,1.341 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "_x31__1_",
    fill: "#CF142B",
    points: "47.966,22.658 34.643,15.995 31.979,15.995 47.966,24 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "22.612,33.117 24,28.8 25.388,33.117 29.629,31.511 27.12,35.288 31.019,37.602 26.502,37.995  27.124,42.487 24,39.2 20.876,42.487 21.498,37.995 16.98,37.602 20.88,35.288 18.371,31.511 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/Australia.3346d2dff3890ba725743c96637c7e05.svg";
export { ForwardRef as ReactComponent };